export function getValidatedLabel(rest: any, label: string): string {
    if (rest && rest.labelprefixed) {
        return `* ${label}`;
    } else {
        return label;
    }
}
